import mapActions from './mapActions';

export default mapActions('order_material_item_documents', {
    fetchAll_url: (data) => {
        return `/api/orders/${data.orderId}/documents/${data.code}`;
    }
});